import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PdfViewer from 'pdf/PdfViewer';
import {getPdfStatement, CARD_GET_PDF_STATEMENT} from './redux';
import {actionPending, actionFail} from 'utils/redux/thunkActionHelpers';
import LoadingBlocking from 'components/loading/LoadingBlocking';
import DocumentFailure from './DocumentFailure';
import moment from "moment";

@connect(
  (state, ownProps) => {
    return {
      fileDate: ownProps.params.fileDate,
      document: state.document.pdfStatement,
      actionType: state.document.type,
      actionStatus: state.document.status,
    };
  },
  dispatch => (bindActionCreators({getPdfStatement}, dispatch))
)
export default class PdfStatementController extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isStatementOnly: false,
      isSupDocOnly: false,
    };
  }

  static propTypes = {
    fileDate: PropTypes.string.isRequired,
    document: PropTypes.object,
    actionType: PropTypes.string,
    actionStatus: PropTypes.string,
    getPdfStatement: PropTypes.func,
  };

  componentDidMount() {
    const currentUrlQueryParams = window.location.search;
    const queryParams = new URLSearchParams(currentUrlQueryParams);
    const statementOnly = queryParams.get('statementOnly');
    const supDocOnly = queryParams.get('supDocOnly');
    this.setState((prevState) => {
      return {
        ...prevState,
        isStatementOnly: !!statementOnly,
        isSupDocOnly: !!supDocOnly,
      };
    });
    this.props.getPdfStatement(this.props.fileDate, !!statementOnly, !!supDocOnly);
  }

  renderComponent = () => {
    let content;
    if (this.state.isStatementOnly) {
      content = this.props.document.statementFileDTO.content;
    } else if (this.state.isSupDocOnly) {
      content = this.props.document.bnplSupplementalDocFileDTO.content;
    }
    if (!content) {
      return <DocumentFailure/>;
    }

    return (<PdfViewer pdfData={content}
                       fileName={`Sunbit-${this.props.document.closingDate}-${moment(new Date).format('MM/DD/YYYY')}`}
                       isLiterallyPdf={true}/>);
  };

  render() {
    if (!this.props.actionStatus || actionPending(CARD_GET_PDF_STATEMENT, this.props.actionType, this.props.actionStatus)) {
      return (<LoadingBlocking />);
    }

    if (actionFail(CARD_GET_PDF_STATEMENT, this.props.actionType, this.props.actionStatus)) {
      return <DocumentFailure />;
    }

    return this.renderComponent();

  }
}



// WEBPACK FOOTER //
// ./src/pdf/DocumentPdfStatmentController.js